export function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-400 py-8 md:py-12 no-print">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="text-xl font-bold text-white mb-4">
              My Best Day
            </div>
            <p className="text-sm">
              AI-powered productivity tips and goal prioritization to help you achieve more.
            </p>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Product</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="https://mybestday.ai" className="hover:text-white">
                  My Best Day App
                </a>
              </li>
              <li>
                <a href="https://mybestday.ai#features" className="hover:text-white">
                  Features
                </a>
              </li>
              <li>
                <a href="https://mybestday.ai#pricing" className="hover:text-white">
                  Pricing
                </a>
              </li>
              <li>
                <a
                  href="https://apps.apple.com/us/app/my-best-day-ai/id6754291484"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white"
                >
                  iOS App
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="https://mybestday.ai/privacy" className="hover:text-white">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="https://mybestday.ai/terms" className="hover:text-white">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="https://mybestday.ai/support" className="hover:text-white">
                  Support
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8 text-center text-sm">
          <p>&copy; 2025 My Best Day. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
